import {
  Box,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
  styled,
  InputLabel,
} from "@mui/material";
import styles from "./volunteer.module.scss";
// import { useNavigate, useParams } from "react-router-dom";
import { ChangeEvent, useState } from "react";
import { ValidationError, object, string } from "yup";
import { below18FormProps } from "./volunteerRegistration";
import { CommonButton, ContactNumberInput, CustomCheckbox } from "../common/StyledComponents/StyledFields";

interface below18Props {
  below18FormData: below18FormProps;
  setBelow18FormData: React.Dispatch<React.SetStateAction<below18FormProps>>;
  callApi: () => void;
  parentName: string;
  ParticipantName : string;
  setShowBelow18: React.Dispatch<React.SetStateAction<boolean>>
  setShowRegisterForm: React.Dispatch<React.SetStateAction<boolean>>
}

export const CustomTextFeild = styled(TextField)`
  & input {
    background-color: #fff9e4;
    // width: 327px;
    padding: 14px 16px;
    border-radius: 8px;
    height: 20px;
    border: 1px solid rgba(136, 46, 20, 0.4);
  }
  & fieldset {
    border-style: unset;
  }
`;

const Below18 = (props: below18Props) => {
  const [checked, setChecked] = useState(false);

  const [errorMessage, setErrorMessage] = useState<below18FormProps>({
    parentPhoneNo: "",
    parentEmailId: "",
  });

  const validationSchema = object().shape({
    parentPhoneNo: string()
        .required("Phone Number is required")
        .matches(/^\d{10}$/, "Phone Number should be 10 digits"),
    parentEmailId: string()
      .email("Invalid email address")
      .required("Email is required")
      .matches(
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
        "Invalid email address format"
      )
  });

  const handleFieldChange = (field: string, value: any) => {
    props.setBelow18FormData({
      ...props.below18FormData,
      [field]: value,
    });
    console.log(value,"value")
  };

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setChecked(event.target.checked);
  };

  const handleSave = async (): Promise<void> => {
    console.log(props.below18FormData);
    const errors: below18FormProps = {
      parentPhoneNo: "",
      parentEmailId: "",
    };
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(props.below18FormData, {
        abortEarly: false,
      });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // alert('Registration Successful');
      // Call your API or perform other actions here
      console.log("gagg")
      props.callApi();
      // console.log("Register Successful")
    } catch (error: any) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e: any) => {
          if (e.path) {
            errors[e.path as keyof below18FormProps] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const CustomInputLabel = (text: string, required: boolean) => {
    return (
      <InputLabel>
        {text}
        {required && (
          <Typography
            component="span"
            sx={{ color: "red", marginLeft: 1, marginBottom: 0 }}
          >
            *
          </Typography>
        )}
      </InputLabel>
    );
  };

  const handleCancel = () : void => {
    props.setShowBelow18(false);
    props.setShowRegisterForm(true);
  };

  const validateAlphabetsAndSpaces = (value: string) => {
    const regex = /^[a-zA-Z\s]*$/;
    return regex.test(value);
  };

  return (
    <Box className={styles.totalConatiner}>
      <Typography className={styles.Heading}>
        UNCONDITONAL RELEASE OF LIABILITY & AGREEMENT TO INDEMNIFY
        <br />
        <Typography className={styles.Heading}>
          (the "Agreement")
        </Typography>{" "}
        <br /> ***THIS IS A LEGALLY BINDING AGREEMENT, PLEASE READ CAREFULLY***
      </Typography>
      <Typography className={styles.subHeading}>
        <strong>Participant:</strong> <span style={{textDecoration:"underline", fontWeight:"bold"}}>{`${props.ParticipantName}`}</span>
      </Typography>
      <Typography className={styles.subHeading}>
        <b>Program:</b> Volunteering in Frontdesk/Kitchen/Maintenance/Temple{" "}
        <b> Location:</b> HCCC Livermore
      </Typography>
      <Box className={styles.theory}>
        <ul>
          <li>
            <Typography>
              <strong>PARTIES BOUND BY THIS AGREEMENT</strong>
            </Typography>
            <li className={styles.outerCircle}>
              <strong>HCCC:</strong> As used in this agreement, the term HCCC
              includes Hindu Community and Cultural Center, Inc and its
              Directors and Officers together with all the volunteers and
              coordinators, employees, and agents.
            </li>
            <li className={styles.outerCircle}>
              <strong>CHILD/PARTICIPANT:</strong> As used in this agreement, the
              term Child/Youth or Participant includes the individual
              participants in the program stated above, the participant’s
              parents, guardians, and heirs.
            </li>
          </li>
          <li>
            <Typography>
              <strong>UNCONDITIONAL RELEASE OF LIABILITY</strong>
            </Typography>
            <li className={styles.outerCircle}>
              In consideration for my child/youth <span style={{textDecoration:"underline", fontWeight:"bold"}}>{`${props.ParticipantName}`}</span>,
              being permitted to participate in the HCCC program described
              above, I, <span style={{textDecoration:"underline", fontWeight:"bold"}}>{`${props.parentName}`}</span>, hereby release HCCC from any and
              all claims and liability of any kind that may arise as a result of
              my child’s participation, including but not limited to claims
              regarding or alleging HCCC’s negligence. This release includes all
              travel to and from the program and activities in preparation for
              participation in the program described above. By signing this
              agreement, the Participant releases HCCC of any and all liability,
              waives any and all claims against HCCC, and agrees not to sue HCCC
              based on the participant’s involvement in the program stated
              above.
            </li>
          </li>
          <li>
            <Typography>
              <strong>AGREEMENT TO INDEMNIFY</strong>
            </Typography>
            <li className={styles.outerCircle}>
              As further consideration of my child’s participation in the HCCC
              program described above, I agree to hold harmless and indemnify
              HCCC for any and all claims that may be brought against HCCC as a
              result of my child’s participation in the program stated above,
              including all costs and attorney fees incurred, as well as any
              other expenses.
            </li>
          </li>
          <li>
            <Typography>
              <strong>SEVERABILITY</strong>
            </Typography>
            <li className={styles.outerCircle}>
              In the event that any term of this agreement is found to be
              invalid for any reason, such a finding shall not affect the
              validity of any other terms of this Agreement.
            </li>
          </li>
          <li>
            <Typography>
              <strong>PARENTS/GUARDIAN(S) CONSENT AND ACKNOWLEDGMENT</strong>
            </Typography>
            <li className={styles.outerCircle}>
              I have read and fully understand the terms of this Agreement,<strong> I
              UNDERSTAND THAT I HAVE GIVEN UP SUBSTANTIAL RIGHT BY SIGNING THIS
              DOCUMENT.</strong>
            </li>
          </li>
        </ul>
      </Box>

      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={4}>
          {CustomInputLabel("Parent Name", true)}
          <CustomTextFeild
            fullWidth
            required
            value={props.parentName}
            InputProps={{
              readOnly: true,
            }}
          />
          
        </Grid>

        <Grid item xs={4}>
          {CustomInputLabel("Parent Phone No:", true)}
          <CustomTextFeild
          fullWidth
            required
            value={props.below18FormData.parentPhoneNo}
            onChange={(e: React.ChangeEvent<HTMLInputElement>)  => {
              setErrorMessage({ ...errorMessage, parentPhoneNo: "" });
              const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
              const slicedNumber = inputNumber.slice(0, 10); // Limit to 10 digits
              handleFieldChange("parentPhoneNo", slicedNumber);
            }}
            placeholder="Enter Parent No."
          />
          {errorMessage.parentPhoneNo && (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.parentPhoneNo}
            </Typography>
          )}
        </Grid>

        <Grid item xs={4}>
          {CustomInputLabel("Parent Email ID:", true)}
          <CustomTextFeild
            fullWidth
            required
            value={props.below18FormData.parentEmailId}
            onChange={(e) => {
              setErrorMessage({ ...errorMessage, parentEmailId: "" });
              handleFieldChange("parentEmailId", e.target.value);
            }}
            placeholder="Enter Parent Email"
          />
          {errorMessage.parentEmailId && (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.parentEmailId}
            </Typography>
          )}
        </Grid>
      </Grid>
      <Box>
        <FormControlLabel
          control={
            <CustomCheckbox checked={checked} onChange={handleCheckboxChange} />
          }
          label="I Agree to the terms and conditions"
        />
      </Box>
      <Box sx={{ display: "flex" }}>
          <CommonButton
          onClick={handleCancel}
          sx={{
            marginTop: "10px",
            display: " inline-flex",
            height: "38px",
            padding: " 8px 16px",
            alignItems: "flex-start",
            gap: "10px",
          }}
        >
          Cancel
        </CommonButton>
        <CommonButton
          disabled={!checked}
          onClick={handleSave}
          sx={{
            marginTop: "10px",
            display: " inline-flex",
            height: "38px",
            padding: " 8px 16px",
            alignItems: "flex-start",
            gap: "10px",
            marginLeft: "17.5px",
          }}
        >
          Submit
        </CommonButton>
      </Box>
    </Box>
  );
};

export default Below18;
